import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectChangesToYourJourneyStep = (state) => state.get('changesToYourJourneyStep');

const makeSelectChangesToYourJourneyStep = () => createSelector(
  selectChangesToYourJourneyStep,
  (changesToYourJourneyStepState) => ({
    tripCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'tripCancellation']),
      ''
    ),

    reasonForTripCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForTripCancellation']),
      ''
    ),

    reasonForTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForTravelCancellation']),
      ''
    ),

    areYouCancellingTheTripDueToMedicalReasons: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'areYouCancellingTheTripDueToMedicalReasons']),
      ''
    ),

    dateTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateTravelCancellation']),
      ''
    ),

    nameOfPersonHavingSicknessTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfPersonHavingSicknessTravelCancellation']),
      ''
    ),

    dateOfBirthTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfBirthTravelCancellation']),
      ''
    ),

    relationshipToClaimantTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'relationshipToClaimantTravelCancellation']),
      ''
    ),

    dateSicknessOrInjuryBeganTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateSicknessOrInjuryBeganTravelCancellation']),
      ''
    ),

    dateEndedTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateEndedTravelCancellation']),
      ''
    ),

    natureOfSicknessOrInjuryTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'natureOfSicknessOrInjuryTravelCancellation']),
      ''
    ),

    fromDateTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'fromDateTravelCancellation']),
      ''
    ),

    toDateTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'toDateTravelCancellation']),
      ''
    ),

    lossInformationItemsTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTravelCancellation']) && changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTravelCancellation']).toJS(), ''),
    insuredsTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'insuredsTravelCancellation']) && changesToYourJourneyStepState.getIn(['form', 'insuredsTravelCancellation']).toJS(), ''),
    enableTimeTravelCancellation: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'enableTimeTravelCancellation']), null),

    // Trip Cancellation for Any Reason
    tripCancellationForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'tripCancellationForAnyReason']),
      ''
    ),

    areYouCancellingTheTripDueToMedicalReasonsForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'areYouCancellingTheTripDueToMedicalReasonsForAnyReason']),
      ''
    ),

    dateTripCancellationForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateTripCancellationForAnyReason']),
      ''
    ),

    reasonForTripCancellationForAnyReason: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForTripCancellationForAnyReason']),
      ''
    ),

    lossInformationItemsTripCancellationForAnyReason: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']) && changesToYourJourneyStepState.getIn(['form', 'lossInformationItemsTripCancellationForAnyReason']).toJS(), ''),
    insuredsTripCancellationForAnyReason: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'insuredsTripCancellationForAnyReason']) && changesToYourJourneyStepState.getIn(['form', 'insuredsTripCancellationForAnyReason']).toJS(), ''),
    travelSuppliersTripCancellationForAnyReason: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTripCancellationForAnyReason']) && changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTripCancellationForAnyReason']).toJS(), ''),

    // Trip Interruption
    travelInterruption: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'travelInterruption']),
      ''
    ),

    reasonsForTripInterruption: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonsForTripInterruption']),
      ''
    ),

    dateTripInterrupted: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateTripInterrupted']),
      ''
    ),

    reasonForInterruption: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonForInterruption']),
      ''
    ),

    nameOfPersonHavingSickness: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'nameOfPersonHavingSickness']),
      ''
    ),

    dateOfBirth: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateOfBirth']),
      ''
    ),

    relationshipToClaimant: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'relationshipToClaimant']),
      ''
    ),

    dateSicknessOrInjuryBegan: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),

    dateEnded: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateEnded']),
      ''
    ),

    natureOfSicknessOrInjury: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'natureOfSicknessOrInjury']),
      ''
    ),

    periodOfHospitalization: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'periodOfHospitalization']),
      ''
    ),

    fromDate: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'toDate']),
      ''
    ),

    insuredsForInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'insuredsForInterruption']) && changesToYourJourneyStepState.getIn(['form', 'insuredsForInterruption']).toJS(), ''),
    travelSuppliersTravelInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTravelInterruption']) && changesToYourJourneyStepState.getIn(['form', 'travelSuppliersTravelInterruption']).toJS(), ''),
    enableTimeInterruption: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'enableTimeInterruption']), null),
    lossInformationItems: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'lossInformationItems']) && changesToYourJourneyStepState.getIn(['form', 'lossInformationItems']).toJS(), ''),

    companyNameLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentAmountOfLoss']), ''),
    amountClaimed: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'amountClaimed']), ''),
    currentClaimed: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentClaimed']), ''),
    haveYouReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'enableTime']), null),
    selectedClaimFor: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'selectedClaimFor']) && changesToYourJourneyStepState.getIn(['form', 'selectedClaimFor']).toJS(), ''),

    travelDelay: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'travelDelay']),
      ''
    ),

    detailsRegardingYourTripDelay: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'detailsRegardingYourTripDelay']),
      ''
    ),

    didTheDelayOccurDuringDeparture: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'didTheDelayOccurDuringDeparture']),
      ''
    ),

    didTheDelayOccurDuringArrival: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'didTheDelayOccurDuringArrival']),
      ''
    ),

    dateYouWereDueToDepart: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateYouWereDueToDepart']),
      ''
    ),

    timeYouWereDueToDepart: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'timeYouWereDueToDepart']),
      ''
    ),

    dateTripWasDelayed: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateTripWasDelayed']),
      ''
    ),

    dateDelayEnded: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateDelayEnded']),
      ''
    ),

    dateYouActuallyDeparted: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'dateYouActuallyDeparted']),
      ''
    ),

    timeYouActuallyDeparted: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'timeYouActuallyDeparted']),
      ''
    ),

    delayInformationItems: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'delayInformationItems']) && changesToYourJourneyStepState.getIn(['form', 'delayInformationItems']).toJS(),
      ''
    ),

    scheduledDateOfDeparture: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledDateOfDeparture']),
      ''
    ),

    scheduledTimeOfDeparture: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledTimeOfDeparture']),
      ''
    ),

    actualDateOfDeparture: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualDateOfDeparture']),
      ''
    ),

    actualTimeOfDeparture: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualTimeOfDeparture']),
      ''
    ),

    scheduledDateOfArrival: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledDateOfArrival']),
      ''
    ),

    scheduledTimeOfArrival: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledTimeOfArrival']),
      ''
    ),

    actualDateOfArrival: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualDateOfArrival']),
      ''
    ),

    actualTimeOfArrival: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualTimeOfArrival']),
      ''
    ),

    reasonsForDelay: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonsForDelay']),
      ''
    ),

    // Missed Connection
    missedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'missedConnection']),
      ''
    ),

    scheduledDateOfDepartureForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledDateOfDepartureForMissedConnection']),
      ''
    ),

    scheduledTimeOfDepartureForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledTimeOfDepartureForMissedConnection']),
      ''
    ),

    scheduledDateOfArrivalForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledDateOfArrivalForMissedConnection']),
      ''
    ),

    scheduledTimeOfArrivalForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'scheduledTimeOfArrivalForMissedConnection']),
      ''
    ),

    didTheDelayOccurDuringDepartureForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'didTheDelayOccurDuringDepartureForMissedConnection']),
      ''
    ),

    didTheDelayOccurDuringArrivalForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'didTheDelayOccurDuringArrivalForMissedConnection']),
      ''
    ),

    detailsRegardingYourMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'detailsRegardingYourMissedConnection']),
      ''
    ),

    reasonsForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'reasonsForMissedConnection']),
      ''
    ),

    actualDateOfDeparturForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualDateOfDeparturForMissedConnection']),
      ''
    ),

    actualTimeOfDepartureForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualTimeOfDepartureForMissedConnection']),
      ''
    ),

    actualDateOfArrivalForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualDateOfArrivalForMissedConnection']),
      ''
    ),

    actualTimeOfArrivalForMissedConnection: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'actualTimeOfArrivalForMissedConnection']),
      ''
    ),

    missedConnectionInformationItems: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'missedConnectionInformationItems']) && changesToYourJourneyStepState.getIn(['form', 'missedConnectionInformationItems']).toJS(),
      ''
    ),

    // Fight Aware API
    flighDetailsWeatherRelated: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'flighDetailsWeatherRelated']).toJS(), ''),
    flightNumber: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'flightNumber']),
      ''
    ),

    flightDate: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'flightDate']),
      ''
    ),

    onPendingFlighAPIRequest: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'onPendingFlighAPIRequest']),
      ''
    ),

    onSuccessFlighAPIRequest: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'onSuccessFlighAPIRequest']),
      ''
    ),

    callFailFlighAPIRequest: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'callFailFlighAPIRequest']),
      ''
    ),

    manuallyEnterFlight: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'manuallyEnterFlight']),
      ''
    ),

    typeOfTransportTravelCancellation: mapWithDefault(
      changesToYourJourneyStepState,
      () => changesToYourJourneyStepState.getIn(['form', 'typeOfTransportTravelCancellation']),
      ''
    ),
    // Cruise Line
    cruiseLineDetailsWeatherRelated: mapWithDefault(changesToYourJourneyStepState, () => changesToYourJourneyStepState.getIn(['form', 'cruiseLineDetailsWeatherRelated']).toJS(), ''),

  })
);

const makeSelectChangesToYourJourneyStepErrors = () =>
  createSelector(selectChangesToYourJourneyStep, (state) => state.get('errors'));

export {
  makeSelectChangesToYourJourneyStep,
  makeSelectChangesToYourJourneyStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/selectors.js